
import { defineComponent, PropType, ref, onMounted } from 'vue'

interface InputSelectOption {
  value: string | number;
  display: string | number;
}

export default defineComponent({
  name: 'InputSelect',
  emits: ['update:modelValue', 'select'],
  props: {
    modelValue: [String, Number, Boolean] as PropType<string | number | null>,
    options: {
      type: Object as PropType<InputSelectOption[]>,
      required: true
    },
    placeholder: String
  },
  setup(props, { emit }) {
    const selected = ref<InputSelectOption | null>(null)
    const open = ref(false)

    function selectOption(i: number) {
      selected.value = props.options[i]
      emit('update:modelValue', props.options[i].value)
      emit('select', props.options[i].value)
    }

    onMounted(() => {  
      selected.value = props.options.find(obj => obj.value ===  props.modelValue) || null
    })

    return { selectOption, selected, open }
  }
})
